import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApiRestService as ClientiApiRestService} from "../../Admin/_service/api-rest.service";
import {ClassicType} from "../../shared/models/ClassicType";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ToastrService} from "ngx-toastr";
import {DownloadService} from "../../shared/_services/download.service";
import {TranslateService} from "@ngx-translate/core";
import {ApiPathsService} from "../../api-paths.service";

@Component ({
  selector: 'app-lavorazioni',
  templateUrl: './report.component.html'
})

export class ReportComponent implements OnInit {
  @Input() Reports: any;
  @Output() ReportsChange = new EventEmitter<any>();
  @Input() filtri: {anno: number, filtro: 'F' | 'T' | 'L' | 'P'|'D', tipi: number[], statiSelezionati: {id: 'F' | 'T' | 'L' | 'P'| 'D', label: string}[], tipiSelezionati, clienti: boolean };
  TipiCliente: ClassicType[] = [];
  titolo = "Report";
  stati: {id: string, label: string}[] = [
    {id: 'T', label: 'Tutti'},
    {id: 'F', label: 'Fatturato Forecast'},
    {id: 'E', label: 'Fatturato Evaso'},
    {id: 'D', label: 'Da Lavorare'},
    {id: 'L', label: 'Lavorati'},
    {id: 'P', label: 'In lavorazione'},
  ]
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
  };
  statodropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
  };
  chkClienti: boolean = true;
  chktipi: boolean = false;

  constructor(
    private api: ApiPathsService,
    private clientiApiRest: ClientiApiRestService,
    private toastService: ToastrService,
    private downloadService: DownloadService,
    public translate: TranslateService,
    ) { }

  ngOnInit(): void {
    this.filtri = {
      anno: new Date().getFullYear(),
      filtro: 'T',
      tipi: [],
      statiSelezionati: [{id: 'T', label: 'Tutti'}],
      tipiSelezionati: [],
      clienti: true
    }
    this.refreshTable();
  }
  refreshTable() {
    this.clientiApiRest.getTipologieClienti().subscribe(data=>{
      this.TipiCliente = data;
    })
    this.filtri.filtro = this.filtri?.statiSelezionati?.length>0 ? this.filtri?.statiSelezionati[0]?.id : 'T';
    this.filtri.tipi = this.filtri.tipiSelezionati?.map(x => x.id);
    this.api.ClassicPost('/progetti/lavorazioni/report', this.filtri).subscribe(data => {
      this.Reports = data;
    })
  }
  StampaSelezionati(){
    this.api.FilePost('/progetti/lavorazioni/report/print', this.filtri).subscribe(data => {
      this.downloadService.downloadFile(data);
    })
  }


  ChangeListType(t:'T'|'C') {
    if(t == 'C')
    this.chktipi = !this.chktipi;
    if(t == 'T')
    this.chkClienti = !this.chkClienti;
    this.filtri.clienti = this.chkClienti;
    this.refreshTable();
  }
}
